import React from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';

function UserPropertyGroupForm({
  handleSubmit,
  handleChange,
  handleBlur,
  values,
  errors,
  setFieldValue,
  isSubmitting
}) {
  return (
    <Form onSubmit={handleSubmit}>
      {/* User */}
      <Form.Group controlId='user_id'>
        {values.users ? (
          <div>
            <Form.Label>User</Form.Label>
            <Select
              defaultValue={values.user}
              onChange={(option) => setFieldValue('user', option)}
              options={values.users.map((user) => {
                return {
                  value: user.id,
                  label: user.name
                };
              })}
            />
          </div>
        ) : (
          <Form.Label>User<br/>{values.user.label}</Form.Label>
        )}
        {errors.user ? <div className='text-danger'>{errors.user}</div> : null}
      </Form.Group>

      {/* Can Edit */}
      <Form.Group controlId='can_edit'>
        <Form.Check
          custom
          type='checkbox'
          label='Can Edit'
          onChange={() => setFieldValue('can_edit', !values.can_edit)}
          defaultChecked={values.can_edit}
          style={{ zIndex: 0 }}
        />
      </Form.Group>

      {/* Property Role */}
      <Form.Group controlId='property_role_id'>
        <Form.Label>Role</Form.Label>
        <Select
          defaultValue={values.propertyRole}
          onChange={(option) => setFieldValue('propertyRole', option)}
          options={values.propertyRoles.map((propertyRole) => {
            return {
              value: propertyRole.id,
              label: propertyRole.name
            };
          })}
        />
        {errors.propertyRole ? (
          <div className='text-danger'>{errors.propertyRole}</div>
        ) : null}
      </Form.Group>
    </Form>
  );
}

export default UserPropertyGroupForm;
